import { render, staticRenderFns } from "./TablesView.vue?vue&type=template&id=a753ddde&"
import script from "./TablesView.vue?vue&type=script&lang=js&"
export * from "./TablesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports